import { useSelectCardFormHasRequiredFields } from './useSelectCardFormHasRequiredFields';
import { useNewCardFormHasRequiredFields } from './useNewCardFormHasRequiredFields';
import { usePaymentContext } from '../PaymentContext';

export function useHasRequiredFields() {
	const selectCardFormResult = useSelectCardFormHasRequiredFields();
	const newCardFormResult = useNewCardFormHasRequiredFields();
	const { newCard } = usePaymentContext();

	return newCard ? newCardFormResult : selectCardFormResult;
}
